module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABMklEQVQ4je2UTytFQRjGf4ezlYU/WSgslLrx3oXYmI24CB/AyheYT2I9G2VtayWlGzKysJu7kKIQS6S7drG4r4yce51yNspT0zPzNPNr5m16E+PCIJBSkFLgBBgqCthRFOgf+EV3QADqUfYI3AIvUXau+34EbnsrZWAzyla9lWFgV9d1YAJYzwNcUD9WfwLOdH6kfuitNIDlPMCycaGf5v98A/a9lYZxoSsCVtVX8gAB5r2VZ6AG7BkXeoE1XT8AVc2m8wLjZx8Ai8Cst/IK7HgrF8BS1vmWNzQuJMCWt3L/AdRsQ/d8q1874AAw7q3UjAudCuwDSt7KlXEh1Sw3EKCiPgX06HxOfQbozjqUGBduyO421zRrOMZn8S+BU6AETGYB2/XBER2xRnW01N9sDr/SO9rLTRzpG0fcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word.png
// module id = 1105
// module chunks = 0